import { getDriverList, oilTranDetail } from '@/api/capacity';

const state = {
  listData: {
    list: [],
    total: 0,
    tableHeadList: [
      {
        label: '消费记录',
        prop: 'tranNo',
        checked: 1,
        width: 280,
        sortable: true,
      },
      {
        label: '企业',
        prop: 'businessName',
        checked: 1,
        width: 160,
        sortable: true,
      },
      {
        label: '运单号',
        prop: 'waybillNo',
        checked: 1,
        width: 130,
        sortable: true,
      },
      {
        label: '加油站',
        prop: 'stationName',
        checked: 1,
        width: 140,
        sortable: true,
      },
      {
        label: '变动类型',
        prop: 'applyTypeDesc',
        checked: 1,
        width: 100,
        sortable: true,
      },

      {
        label: '消费金额（元）',
        prop: 'amount',
        checked: 1,
        width: 135,
        sortable: true,
        slotName: 'sub-domain-amount',
      },
      {
        label: '变动后余额（元）',
        prop: 'newAmount',
        checked: 1,
        width: 135,
        sortable: true,
        slotName: 'sub-domain-newAmount',
      },
      {
        label: '消费时间',
        prop: 'tranTime',
        checked: 1,
        width: 140,
        sortable: true,
      },
    ],
  },
  postParams: {
    page: 1,
    size: 10,
    driverMobile: '',
  },
};
const getters = {};
const actions = {
  getList: async context => {
    const { code, data } = await oilTranDetail(Object.assign({}, context.state.postParams));
    data.list = data.records;
    context.commit('updateListData', data);
  },
};
const mutations = {
  updateMobile(context, payload) {
    context.state.driverMobile = payload;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  updateListData(state, payload) {
    state.listData = Object.assign({}, state.listData, payload);
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
